import { render, staticRenderFns } from "./configuracaoConta.vue?vue&type=template&id=73b1ee58"
import script from "./configuracaoConta.vue?vue&type=script&lang=js"
export * from "./configuracaoConta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports